import { Navigate } from '@sorare/routing';

import { ANY_SPORT_SCORES_MATCHES } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const ScoutingCenterMatchesPage = () => {
  const { generateSportContextPath } = useSportContext();

  return (
    <Navigate to={generateSportContextPath(ANY_SPORT_SCORES_MATCHES)} replace />
  );
};

export default ScoutingCenterMatchesPage;
